export default __webpack_public_path__ + "static/media/cycles1.3f211f10.png";